import React, {useEffect, useState} from 'react'
import {ParagraphText} from '@thryvlabs/maverick'
import {ADDONS_TYPES, BILLING_PREFERENCES} from '../../utils/constants'
import {QuantityComponent} from './quantity-component'

const MAX_CTN_QUANTITY = 99

const getProduct = (item, quantity, currency) => {
  const availablePlan = item['monthly']
  const productPayment = availablePlan[0]
  if (!productPayment) return

  const productPrice =
    productPayment.currencies.find(x => x.currency === currency)?.unitAmount ||
    0

  const price = Number((productPrice * quantity).toFixed(2))

  return {
    id: productPayment.id,
    product: item.name,
    type: ADDONS_TYPES['ADD_ON'],
    price: `$${price
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
    billingPreference: BILLING_PREFERENCES[0],
    planCode: productPayment.code,
    disableApps: item.disableApps || [],
    quantity,
  }
}

export function CTNAddonV4({
  item,
  addProduct,
  removeProduct,
  updateProduct,
  listOfProducts,
  currentAddOns,
  currency,
}) {
  const code = item.monthly[0].code
  const defaultProduct = currentAddOns?.find(addOn => addOn.addOnCode === code)
  const inListProduct = listOfProducts?.find(
    product => product.planCode === code,
  )
  const minQuantity = defaultProduct?.quantity || 0
  const [quantity, setQuantity] = useState(defaultProduct?.quantity || 0)

  const ctnAddOn = item.monthly[0].currencies.find(
    ({currency: c}) => c === currency,
  )
  const itemPrice = ((ctnAddOn?.unitAmount || 0) * quantity).toFixed(2)

  useEffect(() => {
    if (defaultProduct?.quantity) {
      addProduct([getProduct(item, defaultProduct.quantity, currency)])
    }
  }, [defaultProduct?.quantity, item])

  function handleChange(updaterOrValue) {
    const newQuantity =
      typeof updaterOrValue === 'function'
        ? updaterOrValue(quantity)
        : updaterOrValue
    setQuantity(newQuantity)
    if (newQuantity === 0) {
      if (inListProduct) removeProduct([inListProduct.id])
    } else if (inListProduct) {
      updateProduct({
        ...getProduct(item, newQuantity, currency),
        quantity: newQuantity,
      })
    } else {
      addProduct([getProduct(item, newQuantity, currency)])
    }
  }

  return (
    <div className="ml-3" style={{borderBottom: '1px solid #eee'}}>
      <div className="flex justify-between py-2">
        <div className="col-lg-6">
          <h4
            style={{fontSize: '1.5rem'}}
            className="m-0 font-montserrat font-normal text-thryv-black-500 mr-2 capitalize"
          >
            {item.name}
          </h4>
          <ParagraphText variant="reg" color="thryv-gray-medium-500">
            {'$' + itemPrice}
          </ParagraphText>
        </div>
        <div className="d-flex align-items-center">
          <QuantityComponent
            minQuantity={minQuantity}
            maxQuantity={MAX_CTN_QUANTITY}
            currentCount={quantity}
            setCount={handleChange}
          />
        </div>
      </div>
    </div>
  )
}
